import { useState, useEffect } from 'react'
import { Contract } from 'ethers'

export const useTokenBalance = (address: string, contract: Contract) => {
  const [balance, setBalance] = useState()

  useEffect(() => {
    if (address && contract) {
      contract
        .balanceOf(address)
        .then((res: any) => {
          setBalance(res)
        })
        .catch(() => setBalance(undefined))
    } else {
      setBalance(undefined)
    }
  }, [address, contract])
  return balance
}
